// extracted by mini-css-extract-plugin
export var button = "Pagination-module--button--4297e";
export var container = "Pagination-module--container--4a556";
export var currentPage = "Pagination-module--currentPage--6db46";
export var disabled = "Pagination-module--disabled--ba114";
export var next = "Pagination-module--next--154c1";
export var previous = "Pagination-module--previous--069a0";